import { Button } from '@/shared/ui/button';

interface PaginationProps {
  offset: number;
  pageSize: number;
  /** How many rows the current page actually returned. */
  count: number;
  total: number;
  hasMore: boolean;
  onOffsetChange: (offset: number) => void;
}

/**
 * The footer under every table on this surface.
 *
 * Extracted rather than repeated: this portal has five paginated tables, and
 * offset arithmetic copied five times is offset arithmetic that will be wrong
 * in one of them.
 */
export function Pagination({
  offset,
  pageSize,
  count,
  total,
  hasMore,
  onOffsetChange,
}: PaginationProps) {
  return (
    <div className="flex items-center justify-between text-sm text-muted-foreground">
      <span>
        {total === 0
          ? 'No results'
          : `${String(offset + 1)}–${String(offset + count)} of ${String(total)}`}
      </span>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={offset === 0}
          onClick={() => {
            onOffsetChange(Math.max(0, offset - pageSize));
          }}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          /*
           * hasMore comes from the server rather than being inferred from a full
           * page, which would claim another page exists whenever the total is an
           * exact multiple of the page size.
           */
          disabled={!hasMore}
          onClick={() => {
            onOffsetChange(offset + pageSize);
          }}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
